import $ from "jquery";

const blogsAndArticlesObject = {

    variables: {
       cards: $(".blog_and_articles_inner"),
        url: window.location.href,
    },

    methods : {
        dataLayerObj : function(e, articleName, title) {
            var obj = {
                'articleName' : articleName ?? "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e ? e.currentTarget.innerText.replace(/\n/g, '').trim() : "",
                'pageSection' : title ? title : "Blogs & Articles",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? blogsAndArticlesObject.variables.url.includes("blog") ? "Blogs" : blogsAndArticlesObject.variables.url.substring(blogsAndArticlesObject.variables.url.indexOf(".com/"), blogsAndArticlesObject.variables.url.lastIndexOf('/')  === ".com") && !blogsAndArticlesObject.variables.url.substring(blogsAndArticlesObject.variables.url.indexOf(".com/"), blogsAndArticlesObject.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : ""
            }
            return obj;
        },
        addEqualHeight: function () {
            const cards = blogsAndArticlesObject.variables.cards;

            let maxHeight = 0;
            if ($(window).width() < 768) {
                cards.each(function () {
                let height = $(this).outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
                });
            } else {
                maxHeight = "auto";
            }

            // min-height (not height) keeps the cards equal but lets them grow when
            // text is enlarged (accessibility widget / WCAG 1.4.12 text spacing).
            cards.css("min-height", maxHeight);
            },
    }
}

$(()=>{
    $(".blogsandarticles .view-more-btn").on('click', function(e){
        let title = $(this).closest(".section_blog_and_articles").find(".col-12 h2").text().trim();
        var obj = blogsAndArticlesObject.methods.dataLayerObj(e,null,title);
        createDataLayer('buttonClick',obj);
    });

    $(".blogsandarticles .blog_and_articles .blog_and_articles_inner").on('click', function(e){
        let title = $(this).closest(".section_blog_and_articles").find(".col-12 h2").text().trim();
        let articleName = $(this).find(".blog_and_articles_inner_content .blog_and_articale_title").text().replace(/\n/g, '').trim();
        let buttonText = $(this).find(".read_more").clone().find("svg, .cmp-link__screen-reader-only, .visually-hidden").remove().end().text().replace(/\n/g, '').trim();
        let blogPublishDate = $(this).find(".date_text").text().replace(/\n/g, '').trim();
        var obj = blogsAndArticlesObject.methods.dataLayerObj(null, articleName, title);
        obj.buttonText = buttonText;
        obj.blogPublishDate = blogPublishDate;
        createDataLayer('buttonClick',obj);
    });

	blogsAndArticlesObject.methods.addEqualHeight();

})